"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsPhoneNumberWithPrefix = exports.isPhoneNumberWithPrefix = void 0;
const isNil_1 = __importDefault(require("lodash/isNil"));
const isString_1 = __importDefault(require("lodash/isString"));
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
const google_libphonenumber_1 = require("google-libphonenumber");
// differs from IsSGPhoneNumber as this requires singapore number to start with +65, no special characters allowed
const SINGAPORE_PHONE_NUMBER_REGEX = /^(?!\+?6599)(?!^\+65\d{6}$)^(?:\+?(?:65)?([9,8,6,3]{1}\d{7}))$/;
const SINGAPORE_MOBILE_NUMBER_REGEX = /^(?!\+?6599)(?!^\+65\d{6}$)^(?:\+?(?:65)?([9,8]{1}\d{7}))$/;
const INTERNATIONAL_PHONE_NUMBER_REGEX = /^\+(?:[0-9]\x20?){6,14}[0-9]$/;
const MESSAGE = "should be a valid Singapore/international phone number";
const MOBILE_MESSAGE = "should be a valid Singapore mobile number";
// can validate string with country code or contact domain
// eslint-disable-next-line sonarjs/cognitive-complexity
async function isPhoneNumberWithPrefix(value, args, constraints) {
    let _value = value;
    if (args) {
        const { object } = args;
        if (object && object.countryCode !== undefined) {
            _value = `${object.countryCode}${value}`;
        }
    }
    if ((0, isNil_1.default)(value)) {
        return { pass: false, message: MESSAGE };
    }
    if (!(0, isString_1.default)(_value)) {
        return { pass: false, message: MESSAGE };
    }
    if (_value.slice(0, 3) === "+65") {
        if ((constraints === null || constraints === void 0 ? void 0 : constraints.mobileOnly) === true && !SINGAPORE_MOBILE_NUMBER_REGEX.test(_value)) {
            // use the mobile number regex
            return { pass: false, message: MOBILE_MESSAGE };
        }
        if (!SINGAPORE_PHONE_NUMBER_REGEX.test(_value)) {
            // use the normal phone number regex
            return { pass: false, message: MESSAGE };
        }
    }
    // validate international phone number using google libPhoneNumber
    if (constraints === null || constraints === void 0 ? void 0 : constraints.useGoogleLibPhoneNumber) {
        const phoneUtil = google_libphonenumber_1.PhoneNumberUtil.getInstance();
        try {
            const internationalPhoneNumber = phoneUtil.parse(value);
            if (!phoneUtil.isValidNumber(internationalPhoneNumber)) {
                return { pass: false, message: MESSAGE };
            }
        }
        catch (error) {
            return { pass: false, message: MESSAGE };
        }
    }
    if (!INTERNATIONAL_PHONE_NUMBER_REGEX.test(_value)) {
        return { pass: false, message: MESSAGE };
    }
    return { pass: true };
}
exports.isPhoneNumberWithPrefix = isPhoneNumberWithPrefix;
/**
 * Validates that the value is a valid SG phone number
 */
function IsPhoneNumberWithPrefix(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsPhoneNumberWithPrefix",
        defaultMessage: MESSAGE,
        options,
        constraints,
        validateFn: isPhoneNumberWithPrefix,
    });
}
exports.IsPhoneNumberWithPrefix = IsPhoneNumberWithPrefix;
//# sourceMappingURL=IsPhoneNumberWithPrefix.js.map